import React, { Component } from 'react';

//Styles
import styles from '../../styles/basicComponents/StatusChip.module.css';

// Base colors for each status; if a status is not listed, it will use the default color
const STATUS_COLORS: { [key: string]: string } = {
  'Submitted': '#0F7FE7',
  'Approved - AM': '#EFDB2B',
  'Approved - FIN': '#FB8645',
  'Paid': '#09B01A',
  'Rejected - AM': '#C30E0E',
  'Rejected - FIN': '#C30E0E',
  'Archived': '#877E7E',
  'Active': '#09B01A',
  'Inactive': '#FF0000',
};

const DEFAULT_COLOR = '#877E7E';

// Text color for each status; white by default; black only on very light backgrounds (e.g., the yellow of Approved - AM)
const getContrastText = (hex: string): string => {
  const clean = hex.replace('#', '');
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);

  const luminance = [r, g, b].map((channel) => {
    const value = channel / 255;
    return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
  });
  const L = 0.2126 * luminance[0] + 0.7152 * luminance[1] + 0.0722 * luminance[2];

  // If the luminance is greater than 0.6, use black text; otherwise, use white text
  return L > 0.6 ? '#000000' : '#FFFFFF';
};

interface Props {
  status: string;
}

interface State { }

export default class StatusChip extends Component<Props, State> {
  render() {
    const { status } = this.props;
    const backgroundColor = STATUS_COLORS[status] || DEFAULT_COLOR;
    const color = getContrastText(backgroundColor);
    return (
      <span className={styles.__chip} style={{ backgroundColor, color }}>
        {status}
      </span>
    );
  }
}
